module.exports = __webpack_public_path__ + "img/5J.8f4a935f.png";